import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import smsImage from './../../images/envelope.png'
import './SmsPanelModal.css'
import toast from 'react-hot-toast';
import { updateSmsInfo } from '../../service/customerService';
import { toEnglish, toPersian } from 'persian';
import priceFormat from '../../service/showPriceFormat';

const SmsPanelModal = ({ showModal, handleClose, customer, setNewSmsInfo }) => {

    const [addedPrice, setAddedPrice] = useState('');
    const [customerMembershipTemplate, setCustomerMembershipTemplate] = useState('');
    const [driverRemainTemplate, setDriverRemainTemplate] = useState('');
    const [addDriverFishTemplate, setAddDriverFishTemplate] = useState('');
    const [reduceDriverFishTemplate, setReduceDriverFishTemplate] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!showModal && (addedPrice)) {
            setAddedPrice('');
        }
        if (!showModal && (customerMembershipTemplate)) {
            setCustomerMembershipTemplate('');
        }
        if (!showModal && (driverRemainTemplate)) {
            setDriverRemainTemplate('');
        }
        if (!showModal && (addDriverFishTemplate)) {
            setAddDriverFishTemplate('');
        }
        if (!showModal && (reduceDriverFishTemplate)) {
            setReduceDriverFishTemplate('');
        }
        if (showModal && customer) {
            setDriverRemainTemplate(customer.sms.driverRemain || '')
            setCustomerMembershipTemplate(customer.sms.customerMembership || '')
            setAddDriverFishTemplate(customer.sms.addDriverFish || '')
            setReduceDriverFishTemplate(customer.sms.reduceDriverFish || '')
        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal])

    const saveSmsPanelInfoHandler = async (event) => {
        event.preventDefault();
        try {
            const params = {
                companyName: customer.companyName,
                templatesObj: {
                    driverRemain: driverRemainTemplate,
                    addDriverFish: addDriverFishTemplate,
                    reduceDriverFish: reduceDriverFishTemplate,
                    customerMembership: customerMembershipTemplate
                },
                addedPrice: addedPrice
            }
            setIsLoading(true);
            const { status } = await updateSmsInfo(params);
            if (status === 201) {
                setNewSmsInfo(customer.companyName, params)
                toast.success('عملیات با موفقیت انجام شد')
                handleClose();
            }

        } catch (err) {
            if (err.response && err.response.status === 404) {
                toast.error('کاربر یافت نشد')
            }
            else {
                toast.error('خطایی رخ داده است')
            }
        }
        setIsLoading(false)
    };



    return (
        <Modal
            size="lg"
            show={showModal}
            onHide={handleClose}
            aria-labelledby="example22-modal-sizes-title-sm"
            backdrop="static"
            className='info-modal-layer'
        >
            <Modal.Header>
                <Modal.Title id="license2-modal-sizes-title-sm" className='rtl d-flex align-items-center ml-auto'>
                    <img src={smsImage} alt="" style={{ width: "40px", marginLeft: '10px' }} />
                    تنظیمات پیامکی
                </Modal.Title>
            </Modal.Header>
            {
                customer &&
                <Modal.Body className='rtl row '>
                    <Form.Group className="mb-3 col-12" >
                        <Form.Label>افزایش موجودی (ریال)</Form.Label>
                        <Form.Control
                            style={{ fontSize: '.8rem' }}
                            type="Tel"
                            autoComplete='off'
                            className='ltr'
                            placeholder='مبلغ (ریال)'
                            value={toPersian(priceFormat(toEnglish(addedPrice)))}
                            onChange={(e) => setAddedPrice(Number(toEnglish(e.target.value.replace(/,/g, ''))))}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3 col-12 col-sm-6" >
                        <Form.Label>عنوان قالب عضویت مشتری</Form.Label>
                        <Form.Control
                            style={{ fontSize: '.8rem' }}
                            type="text"
                            autoComplete='off'
                            className='ltr'
                            value={customerMembershipTemplate}
                            onChange={e => setCustomerMembershipTemplate(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3 col-12 col-sm-6" >
                        <Form.Label>عنوان قالب باقیمانده اعتبار راننده</Form.Label>
                        <Form.Control
                            style={{ fontSize: '.8rem' }}
                            type="text"
                            autoComplete='off'
                            className='ltr'
                            value={driverRemainTemplate}
                            onChange={e => setDriverRemainTemplate(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3 col-12 col-sm-6" >
                        <Form.Label>عنوان قالب افزودن فیش راننده</Form.Label>
                        <Form.Control
                            style={{ fontSize: '.8rem' }}
                            type="text"
                            autoComplete='off'
                            className='ltr'
                            value={addDriverFishTemplate}
                            onChange={e => setAddDriverFishTemplate(e.target.value)}
                        />
                    </Form.Group> 
                    <Form.Group className="mb-3 col-12 col-sm-6" >
                        <Form.Label>عنوان قالب کسر شدن فیش راننده</Form.Label>
                        <Form.Control
                            style={{ fontSize: '.8rem' }}
                            type="text"
                            autoComplete='off'
                            className='ltr'
                            value={reduceDriverFishTemplate}
                            onChange={e => setReduceDriverFishTemplate(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
            }
            <Modal.Footer>
                <Button variant="secondary w-25" onClick={handleClose} disabled={isLoading}>
                    لغو
                </Button>
                <Button variant="success w-25" disabled={isLoading} onClick={saveSmsPanelInfoHandler}>
                    ذخیره
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default SmsPanelModal;